import React from 'react';
import Icon from '../../../components/AppIcon';

const CampaignROITable = ({ data = [] }) => {
  if (data?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-12 text-center">
        <Icon name="Table" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
        <p className="text-muted-foreground">No campaign ROI data available yet</p>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1 overflow-hidden">
      <div className="p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Campaign ROI</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-muted/50">
              <th className="text-left px-4 py-3 text-xs font-medium text-muted-foreground">Campaign</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-muted-foreground">Type</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-muted-foreground">Status</th>
              <th className="text-right px-4 py-3 text-xs font-medium text-muted-foreground">Recipients</th>
              <th className="text-right px-4 py-3 text-xs font-medium text-muted-foreground">Est. Revenue</th>
              <th className="text-right px-4 py-3 text-xs font-medium text-muted-foreground">ROI</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {data?.map((campaign, index) => (
              <tr key={campaign?.id || index} className="hover:bg-muted/30 transition-colors">
                <td className="px-4 py-3 text-sm font-medium text-foreground">{campaign?.name || 'Unnamed'}</td>
                <td className="px-4 py-3 text-sm text-muted-foreground capitalize">{campaign?.type || 'email'}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${
                    campaign?.status === 'active' ? 'bg-success/10 text-success' :
                    campaign?.status === 'completed'? 'bg-blue-100 text-blue-700' : 'bg-muted text-muted-foreground'
                  }`}>{campaign?.status || 'draft'}</span>
                </td>
                <td className="px-4 py-3 text-sm text-right text-foreground">{(campaign?.recipient_count || 0)?.toLocaleString()}</td>
                <td className="px-4 py-3 text-sm text-right text-foreground">${(campaign?.revenue || 0)?.toLocaleString()}</td>
                <td className="px-4 py-3 text-sm text-right font-medium text-success">{campaign?.roi || 0}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CampaignROITable;